import type { MenuItem } from '@/types';

/**
 * Getting Started Menu
 */
export const getStartedMenu: MenuItem[] = [
  { label: 'Getting Started', path: '/getting-started' },
  { label: 'Advanced Demo', path: '/getting-started/advanced-demo' },
];

/**
 * Popular KB Article Menu
 */
export const popularMenu: MenuItem[] = [
  {
    label: 'Does Phenix Encrypt Its Real-Time Streams?',
    path: '/knowledge-base/faqs/does-phenix-encrypt-its-real-time-streams',
  },
  {
    label: 'How Does Phenix Define Real-Time vs Low Latency',
    path: '/knowledge-base/faqs/how-does-phenix-define-real-time-vs-low-latency',
  },
];

/**
 * Recently Added KB Article Menu
 */
export const recentMenu: MenuItem[] = [
  {
    label: 'How Does Phenix Compare with Protocols like CMAF',
    path: '/knowledge-base/faqs/how-does-phenix-real-time-streaming-compare-with-protocols-such-as-cmaf',
  },
  {
    label: 'On Which Cloud Platforms is the Phenix Platform Deployed',
    path: '/knowledge-base/faqs/on-which-cloud-platforms-is-the-phenix-platform-deployed',
  },
];
